/// <reference types="@angular/localize" />

/// <reference types="google.maps" />
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {AppModule} from "./app/app.module";
import {enableProdMode, provideZoneChangeDetection} from "@angular/core";
import {environment} from "./app/environments/environment";
import {publicHashEntryUrl} from "./app/shared/utils/public-hash-entry";

const normalizePublicEntry = (event?: Event) => {
  const publicEntry = publicHashEntryUrl(window.location.href);
  if (publicEntry) {
    if (event) {
      // A running root route may already hold authenticated-screen state.
      // Replace this legacy entry before its router listeners can activate it.
      event.stopImmediatePropagation();
      window.location.replace(publicEntry);
    } else {
      window.history.replaceState(window.history.state, "", publicEntry);
    }
  }
};
normalizePublicEntry();
// Entering /#/join/... while already at / is a same-document navigation.
// Register before Angular so its Location listener sees the normalized path.
window.addEventListener("hashchange", normalizePublicEntry, true);
window.addEventListener("popstate", normalizePublicEntry, true);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [
    provideZoneChangeDetection()
  ]
});
